import type { RouteObject } from "react-router-dom";
import { ReviewsPage } from "@/modules/reviews/pages/ReviewsPage";

export const reviewsRoutes: RouteObject[] = [
  {
    path: "reviews",
    element: <ReviewsPage />,
  },
];
